var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0941 17.0227L34.5547 0.405055C34.0171 -0.135018 33.1433 -0.135018 32.6058 0.405055C32.0682 0.945127 32.0682 1.82309 32.6058 2.36317L46.7911 16.6155H1.87829C1.11747 16.6155 0.5 17.2359 0.5 18.0003C0.5 18.7648 1.11747 19.3851 1.87829 19.3851H46.7911L32.6058 33.6375C32.0682 34.1776 32.0682 35.0556 32.6058 35.5956C32.8759 35.8671 33.2288 36 33.5816 36C33.9344 36 34.2873 35.8643 34.5574 35.5956L51.0969 18.978C51.6344 18.4379 51.6344 17.56 51.0969 17.0199L51.0941 17.0227Z",
    fill: "#009ee1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightPrimary);
export default __webpack_public_path__ + "static/media/arrow-right-primary.0b34ec52.svg";
export { ForwardRef as ReactComponent };